var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriortyTicketIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3582 7H12.0911C11.7199 7 11.4331 7.30368 11.4331 7.65797C11.4331 8.01226 11.7368 8.31594 12.0911 8.31594H20.3413C20.7125 8.31594 20.9993 8.01226 20.9993 7.65797C20.9993 7.30368 20.7125 7 20.3582 7Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 10.1387H12.0911C11.7199 10.1387 11.4331 10.4424 11.4331 10.7966C11.4331 11.1509 11.7368 11.4546 12.0911 11.4546H18.2998C18.671 11.4546 18.9578 11.1509 18.9578 10.7966C18.9578 10.4424 18.6541 10.1387 18.2998 10.1387Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2415 13.2598H12.0911C11.7199 13.2598 11.4331 13.5634 11.4331 13.9177C11.4331 14.272 11.7368 14.5757 12.0911 14.5757H16.2415C16.6127 14.5757 16.8995 14.272 16.8995 13.9177C16.8995 13.5634 16.6127 13.2598 16.2415 13.2598Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1832 16.3965H12.0911C11.7199 16.3965 11.4331 16.7002 11.4331 17.0545C11.4331 17.4087 11.7368 17.7124 12.0911 17.7124H14.1832C14.5543 17.7124 14.8412 17.4087 14.8412 17.0545C14.8412 16.7002 14.5543 16.3965 14.1832 16.3965Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05797 7.20347C7.80489 6.95041 7.38311 6.95041 7.11316 7.20347L5.1898 9.12677C4.93673 9.37984 4.93673 9.80161 5.1898 10.0716C5.44288 10.3246 5.86467 10.3246 6.13461 10.0716L6.92757 9.27861V17.0562C6.92757 17.4273 7.23126 17.7141 7.58556 17.7141C7.93987 17.7141 8.24355 17.4105 8.24355 17.0562V9.27861L9.03652 10.0716C9.17149 10.2065 9.3402 10.274 9.50892 10.274C9.67764 10.274 9.84635 10.2065 9.98132 10.0716C10.2344 9.81848 10.2344 9.39671 9.98132 9.12677L8.05797 7.20347Z",
    fill: "#6929E2",
    stroke: "#6929E2",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriortyTicketIc);
export default __webpack_public_path__ + "static/media/priorty_ticket_ic.b5d108f8578186b9e8bdb2d1e3e2b191.svg";
export { ForwardRef as ReactComponent };